<template>
  <div class="flex h-full flex-col">
    <div
      class="flex h-full grow flex-col items-center justify-around"
    >
      <IconSetupComplete
        class="size-40 text-background-fg/70"
      />
      <div>
        <div class="mb-4 text-center font-bold">
          Congratulations, you're all setup!
        </div>
        <div
          v-if="merchantName"
          class="text-center text-sm"
        >
          Your device has been successfully paired with
          <b class="text-primary">{{ merchantName }}</b>
        </div>
        <div v-else class="text-center text-sm">
          Your device has been successfully paired
        </div>
      </div>
    </div>
    <ActionButtonPrimary @click="emit('stage-complete')"
      >Start taking payments</ActionButtonPrimary
    >
  </div>
</template>

<script setup lang="ts">
defineProps<{
  merchantName: string | null
}>()

const emit = defineEmits<{
  (eventName: "stage-complete"): void
}>()
</script>
